module.exports = __webpack_public_path__ + "img/logo-b.8f689bdd.png";